<template>
  <div>
    <div class="d-flex flex-column flex-md-row my-5 align-center">
      <div class="d-flex flex-column">
        <div class="font-weight-bold">
          Questões
        </div>
        <div class="text-body-2 text--secondary mt-1">
          Essas questões vão ficar disponíveis para todos os alunos na avaliação.<br>
        </div>
      </div>
      <v-spacer />
      <v-btn
        color="primary"
        text
        @click="newQuestion"
      >
        <v-icon
          small
          left
        >
          mdi-plus
        </v-icon> Nova questão
      </v-btn>
    </div>
    <v-progress-linear
      v-if="loading"
      color="amber"
      indeterminate
    />
    <div v-else>
      <div
        v-if="questions.length === 0"
        class="text-center py-5"
      >
        Nenhuma questão cadastrada.
      </div>
      <v-expansion-panels accordion>
        <v-expansion-panel
          v-for="question in questions"
          :key="question.id"
        >
          <v-expansion-panel-header>
            Questão #{{ question.id }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <router-link :to="{ name: 'exams.examId.groups.groupId.questao.questionId', params: { examId: question.exam_id, groupId: question.exam_question_group_id, questionId: question.id } }">
              Editar
            </router-link>
            <editor-content
              v-if="question.editor"
              :editor="question.editor"
              class="editor-content"
            />
            <div
              v-else
              class="red--text"
            >
              Conteúdo corrompido! Apague esta questão e cadastre-a novamente.
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import { Editor, EditorContent } from 'tiptap'
import {
  HardBreak,
  Bold,
  Italic,
  History
} from 'tiptap-extensions'

import Image from '../questao/nodes/Image'
import Katex from '../questao/nodes/Katex'
// import dayjs from '@/dayjs'

export default {
  components: {
    EditorContent
  },

  mixins: [
    handlesServerValidation
  ],

  props: {
    idGroup: { type: Number, default: null }
  },
  data: () => ({
    loading: true,

    // Questions
    questions: []
  }),

  async created () {
    if (this.idGroup) {
      await this.fetchPage()
    }
  },

  methods: {
    async fetchPage () {
      const params = '?only_common=1'
      try {
        const data = await this.$api.listExamQuestions(this.idGroup, params)
        for (const question of data) {
          try {
            question.editor = new Editor({
              editable: false,
              extensions: [
                new HardBreak(),
                new Bold(),
                new Image(),
                new Italic(),
                new History(),
                new Katex()
              ],
              content: JSON.parse(question.statement)
            })
          } catch (e) {
            question.editor = null
          }
        }

        if (this.questions.length > 0) {
          for (const question of this.questions) {
            question.editor && question.editor.destroy()
          }
        }

        this.questions = data
        // this.totalPages = data.meta.last_page

        this.loading = false
      } catch (e) {
        this.loading = false
        this.$store.dispatch('setSnackBar', { text: 'Ocorreu um erro ao tentar listar as questões.', color: 'red' })
        this.getErrors(e)
      }
    },

    async newQuestion () {
      const text = ''
      const data = {
        statement: JSON.stringify(text),
        options: [
          {
            text: JSON.stringify(text),
            is_correct: true
          },
          {
            text: JSON.stringify(text),
            is_correct: false
          }
        ]
      }
      try {
        const response = await this.$api.newExamQuestions(this.idGroup, data)
        this.goTo(response)
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível criar a questão, tente novamente mais tarde.', color: 'red' })
      }
    },
    goTo (question) {
      this.$router.push({ name: 'exams.examId.groups.groupId.questao.questionId', params: { examId: question.exam_id, groupId: question.exam_question_group_id, questionId: question.id } })
    }
  }
}
</script>
